"use strict";
import m from 'mithril';

let data = {
    company: '',
    message: '',
    messageSent: false,
    serviceUnavailable: false,
    submit: () => m.request(
        {
            body: {
                company: data.company,
                email: data.email,
                message: data.message,
                name: data.name,
                username: data.username
            },
            method: 'POST',
            url: '/contact'
        }
    )
        .then(_ => data.messageSent = true)
        .catch(e => {
            if (e.code === 503) {
                data.serviceUnavailable = true;
            }
        })
};

export default function (container, view) {
    return {
        exec: () => {
            data.email    = container.dataset.email || '';
            data.name     = container.dataset.name || '';
            data.username = container.dataset.username || '';

            m.mount(container, {view: () => m(view, data)});
        }
    };
}